<template>
    <div class="flex flex-col w-full">
        <brand-nav
            class="flex-shrink-0 flex justify-between items-center w-full h-16 px-4 shadow-lg bg-white"
            :class="{ 'xl:hidden': !$configs.inIframe }"
        />

        <div class="flex-1 flex items-stretch flex-no-wrap overflow-hidden">
            <main-nav class="w-18 h-full bg-white hidden | xl:flex | 2xl:w-60" v-if="!$configs.inIframe" />
            <router-view class="w-full" />
        </div>
    </div>
</template>

<script>
    import BrandNav from '@/components/Navs/BrandNav.vue';
    import MainNav from '@/components/Navs/MainNav.vue';

    export default {
        components: {
            BrandNav,
            MainNav,
        },
    };
</script>
